module.exports = __webpack_public_path__ + "static/media/768-products---5-image-4.a41c328d.png";